import {
  Box,
  Button,
  Card,
  CircularProgress,
  Dialog,
  DialogActions,
  DialogContent,
  DialogContentText,
  DialogTitle,
  Divider,
  Grid,
  IconButton,
  MenuItem,
  Table,
  TableBody,
  TableCell,
  TableContainer,
  TableHead,
  TableRow,
  TextField,
  Typography,
  useMediaQuery,
  useTheme,
} from "@mui/material";
import { useNavigate, useParams } from "react-router-dom";
import { useContext, useEffect, useState } from "react";
import { AuthContext } from "../../../context/AuthContext";
import { SnackAlertContext } from "../../../context/SnackAlertContext";
import OrderTitle from "../../../components/OrderTitle";
import PickupForm from "./PickupForm";

const NewPickup = () => {
  const { orderId } = useParams();
  const { ezorder, authToken } = useContext(AuthContext);
  const { openSnackMessage } = useContext(SnackAlertContext);
  const theme = useTheme();
  const isSmallScreen = useMediaQuery(theme.breakpoints.down("sm"));
  const navigate = useNavigate();
  const [orderDetails, setOrderDetails] = useState(null);
  const [pickup, setPickup] = useState();
  const [pickupItems, setPickupItems] = useState([]);
  const [loading, setLoading] = useState(false);

  const getOrderWithPickupHistory = async (orderId) => {
    try {
      setLoading(true);
      const res = await ezorder.get(`/shop/jobs/${orderId}/pickup-history`, {
        headers: {
          Authorization: `Bearer ${authToken}`,
        },
      });
      setOrderDetails(res.data.order);

      // Add Maxed Out Transactions By Default
      let items = res.data.order.pickupHistory.items;
      let transactions = [];
      for (let item of items) {
        // item.toReceive = Number(item.quantity) - Number(item.quantityReceived);
        let transaction = {
          quantity: Number(item.quantity) - Number(item.quantityReceived),
          objectType: item.objectType,
          itemName: item.itemName,
          uom: item.uom,
          pickupItem: { id: item.id },
        };
        transactions.push(transaction);
      }
      setPickupItems(items);
      setPickup({
        pickupType: "PICKUP",
        transactions,
      });
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  const savePickup = async () => {
    try {
      setLoading(true);

      const response = await ezorder.post(
        `/shop/jobs/${orderId}/pickup-history/new-pickup`,
        pickup,
        {
          headers: {
            Authorization: `Bearer ${authToken}`,
          },
        },
      );

      if (response.status == 200 || response.status == 201) {
        openSnackMessage("success", "Saved");
        navigate(`/job-pickups/${orderId}/pickups/${response.data.pickup.id}`);
      } else {
        openSnackMessage("error", response.response.data.error);
      }
    } catch (error) {
      console.log(error);
      // setError(error);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    if (orderId) {
      getOrderWithPickupHistory(orderId);
    }
  }, [orderId]);

  return (
    <Box>
      {orderDetails && (
        <>
          <Box>
            <Box sx={{ display: "flex", flexDirection: "row" }}>
              <Box sx={{ flex: 1 }}>
                <OrderTitle order={orderDetails} includeLink={true} />
              </Box>
            </Box>
          </Box>
          <Typography variant="h5" sx={{ textAlign: "center" }}>
            New Pickup
          </Typography>
          {loading || !orderDetails ? (
            <Box
              sx={{
                width: "100%",
                minHeight: "200px",
                display: "flex",
                alignItems: "center",
                justifyContent: "center",
              }}
            >
              <CircularProgress size="3rem" />
            </Box>
          ) : (
            <PickupForm
              pickupItems={pickupItems}
              pickup={pickup}
              onUpdatePickup={(update) => {
                setPickup((prev) => ({
                  ...prev,
                  ...update,
                }));
              }}
            />
          )}

          <Box
            sx={{
              display: "flex",
              flexDirection: "row",
              justifyContent: "flex-end",
            }}
          >
            <Button
              onClick={() => {
                navigate(`/job-pickups/${orderId}`);
              }}
            >
              Cancel
            </Button>
            <Button
              onClick={() => {
                savePickup();
              }}
            >
              Save
            </Button>
          </Box>
        </>
      )}
    </Box>
  );
};

export default NewPickup;
